import { render, staticRenderFns } from "./BotIcon.vue?vue&type=template&id=000d63ae&"
import script from "./BotIcon.vue?vue&type=script&lang=ts&"
export * from "./BotIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BotIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports